import { render } from "./email-import-form.vue?vue&type=template&id=658cf7b9&scoped=true&ts=true"
import script from "./email-import-form.vue?vue&type=script&lang=ts"
export * from "./email-import-form.vue?vue&type=script&lang=ts"

import "./email-import-form.vue?vue&type=style&index=0&id=658cf7b9&lang=scss&scoped=true"
/* custom blocks */
import block0 from "../i18n/messages.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc3593438386%2Fsrc%2Fpadme-ui-aws%2Fapps%2Fmain%2Fsrc%2Fcomponents%2Femail-import-dialog%2Fcomponents%2Femail-import-form.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-658cf7b9"]])

export default __exports__